import React, { useState } from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const arrowStyle = { width: "20px", height: "20px", flexShrink: 0 };

  const faqs = [
    {
      question: "What does WhatsApp automation mean?",
      answer:
        "WhatsApp automation refers to the use of technology to automatically send, receive, and manage messages on WhatsApp. It helps businesses handle customer inquiries, send updates, promotions, and reminders without manual effort, saving time and improving communication efficiency."
    },

    {
      question: "How does WhatsApp bulk messaging work?",
      answer:
        "WhatsApp bulk messaging allows businesses to send a single message to multiple contacts at once. It is commonly used for announcements, offers, event notifications, and important updates, ensuring quick and consistent communication with a large audience."
    },

    {
      question:
        "Is sending bulk messages on WhatsApp allowed?",
      answer:
        " Bulk messaging is permitted only when it follows WhatsApp’s official policies. Messages must be sent using approved WhatsApp Business APIs, and recipients should have given their consent. Sending unsolicited or spam messages can lead to account restrictions or bans.",
    },

    {
      question: "Can WhatsApp messages be automated for business use?",
      answer:
        "Yes, businesses can automate WhatsApp messages using tools like chatbots and workflows. Automation can handle FAQs, order confirmations, appointment reminders, and customer support queries, helping businesses respond faster and operate more efficiently"
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ background: "#ffffff" }}
    >
      <div className="row mt-4 mb-5">
        <div className="col-lg-3 d-none d-lg-block"></div>
        <div className="col-12 col-lg-6 px-3 px-md-4">
          <h2 className="text-center text-black mt-5 mb-4 fs-4">
            Frequently Asked Questions
          </h2>

          <div className="row ">
            <div className="col-12 p-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <div
                    key={index}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      background: isOpen
                        ? "#F1F5F5"
                        : "#F1F5F5",
                      borderRadius: "12px",
                      padding: "20px 18px",
                      marginBottom: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          minWidth: "200px",
                          color: isOpen ? "#0C4D45" : "#0C4D45",
                          fontWeight: isOpen ? "600" : "400",
                        }}
                      >
                        {faq.question}
                      </p>

                      {isOpen ? (
                        <FiChevronUp style={arrowStyle} color="#000000" />
                      ) : (
                        <FiChevronDown style={arrowStyle} color="#000000e0"/>
                      )}
                    </div>

                    {isOpen && (
                      <p
                        style={{
                          fontSize: "15px",
                          color: "#262728",
                          marginTop: "10px",
                          lineHeight: "1.5",
                          maxWidth: "85%"
                        }}
                      >
                        {faq.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-3 d-none d-lg-block"></div>
      </div>
    </div>
  );
};

export default FaqSection;